import type { FC } from 'react';
import { useCallback } from 'react';

import { Col } from '@opendoor/atoms/box';
import { List, ListItem } from '@opendoor/atoms/list';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import { Button } from 'platform/atoms';
import { useAuthContext } from 'platform/components/AuthContext';
import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/** Page to show when user it not authorized. */
export const NotAuthorizedPage: FC = () => {
  const { logout } = useAuthContext();
  const handleSignOut = useCallback(() => {
    void logout();
  }, [logout]);

  return (
    <GenericErrorPage
      reason="not-authorized"
      causedBy="user-error"
      headerContent="You don’t have permission to view this page"
    >
      <Col className="pt-5 gap-2">
        <Text as="p" className="text-left text-body-md font-bold">
          How can I resolve this?
        </Text>
        <List className="ps-6">
          <ListItem>
            <Button
              variant="secondary"
              analyticsName="account-redirect"
              aria-label="Sign out"
              onClick={handleSignOut}
              className={cn(
                'inline-flex h-auto w-max shrink-0 rounded-none border-0 bg-transparent p-0',
                '[&:is(:hover,:active,:disabled)]:!bg-transparent',
                'text-label-md underline !text-od-content-primary hover:!text-od-content-hover-accent-brand disabled:!text-od-content-inactive-secondary',
              )}
            >
              Sign out
            </Button>{' '}
            <Text as="span" className="text-body-md">
              and try signing into a different account
            </Text>
          </ListItem>
          <ListItem>
            <Text as="span" className="text-body-md">
              If someone added you, contact the owner to get access
            </Text>
          </ListItem>
        </List>
      </Col>
    </GenericErrorPage>
  );
};
